import { pad2, rupiah, tableLabel } from "@/lib/api";

const fmt = (s) => new Date(s).toLocaleString("id-ID", { timeZone: "Asia/Jakarta", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export const Receipt = ({ order, settings }) => (
  <div id="pos-receipt" className="pos-receipt" data-testid="pos-receipt">
    <div className="text-center">
      <div className="font-bold text-base tracking-widest">UPLINK COFFEE</div>
      <div>Gerai {order.outlet_name}</div>
      {settings?.address && <div>{settings.address}</div>}
    </div>
    <div className="rc-line" />
    <div className="rc-row"><span>No</span><span>{order.code}</span></div>
    <div className="rc-row"><span>Waktu</span><span>{fmt(order.created_at)}</span></div>
    <div className="rc-row"><span>Kasir</span><span>{order.cashier}</span></div>
    <div className="rc-row"><span>Pesanan</span><span>{order.order_type === "takeaway" ? "Bawa pulang" : tableLabel(order.floor, order.table)}</span></div>
    {order.customer_name && <div className="rc-row"><span>Nama</span><span>{order.customer_name}</span></div>}
    <div className="rc-line" />
    {order.items.map((i) => (
      <div key={i.menu_id} className="mb-1">
        <div>{i.name}</div>
        <div className="rc-row"><span>{i.qty} x {rupiah(i.price)}</span><span>{rupiah(i.qty * i.price)}</span></div>
        {i.note && <div>  * {i.note}</div>}
      </div>
    ))}
    <div className="rc-line" />
    <div className="rc-row"><span>Subtotal</span><span>{rupiah(order.subtotal)}</span></div>
    <div className="rc-row"><span>{order.tax_name} {order.tax_rate}%</span><span>{rupiah(order.tax_amount)}</span></div>
    <div className="rc-row font-bold text-sm"><span>TOTAL</span><span>{rupiah(order.total)}</span></div>
    <div className="rc-row"><span>Bayar</span><span>QRIS - LUNAS</span></div>
    {order.notes && <div className="mt-1">Catatan: {order.notes}</div>}
    <div className="rc-line" />
    <div className="text-center">Terima kasih!<br />Ngopi santai. Koneksi makin luas.<br />uplinkcoffee.com</div>
    <div className="text-center mt-1">#{pad2(order.number)}</div>
  </div>
);
